module.exports = __webpack_public_path__ + "img/Apfelmassaker.741378ba.jpg";